import { Type } from 'class-transformer'
import { EnumEntity } from '..'

import { Address } from '.'

export class PropertyType extends EnumEntity {
  @Type(() => Address)
  addresses: Address[];
}
